/**
 * UnauthorizedPage - Displayed when user tries to access a route they don't have permission for.
 * Shows current roles and provides navigation to appropriate dashboard.
 */

import { Link } from '@tanstack/react-router'
import { useAuth } from '@/common/hooks/useAuth'
import { Text } from '@/common/components/text'
import * as styles from './unauthorized.css'

export const Route = createFileRoute({
  component: UnauthorizedPage,
})

function UnauthorizedPage() {
  const { user, roles } = useAuth()

  // Determine appropriate landing page link based on user's roles
  // Priority: admin > agent > investor
  const getDashboardLink = () => {
    if (roles.includes('admin')) {
      return '/admin/users'
    }
    if (roles.includes('agent')) {
      return '/properties'
    }
    if (roles.includes('investor')) {
      return '/properties'
    }
    return '/login'
  }

  const dashboardLink = getDashboardLink()

  return (
    <div className={styles.container}>
      <div className={styles.icon}>🚫</div>

      <Text variant="h4" className={styles.title}>Access Denied</Text>
      <Text variant="bodyLg" color="muted" className={styles.description}>
        You don't have the required permissions to access this page.
      </Text>

      {user && (
        <div className={styles.rolesCard}>
          <Text as="h3" variant="body" weight="medium" className={styles.rolesTitle}>
            Your Current Roles:
          </Text>
          <div className={styles.rolesContainer}>
            {roles.length > 0 ? (
              roles.map(role => (
                <span key={role} className={styles.roleBadge}>
                  {role}
                </span>
              ))
            ) : (
              <Text variant="bodySm" color="muted">No roles assigned</Text>
            )}
          </div>
        </div>
      )}

      <div className={styles.actions}>
        <Link to={dashboardLink} className={styles.primaryLink}>
          Go to My Dashboard
        </Link>

        <Link to="/" className={styles.secondaryLink}>
          Go to Home
        </Link>
      </div>

      <Text variant="bodySm" color="muted" className={styles.footer}>
        If you believe you should have access to this page, please contact your administrator.
      </Text>
    </div>
  )
}
